import { Component, OnInit, inject, signal, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { ISessionDetails } from '../../../interfaces/session-details';
import { SharedService } from '../../../services/shared.service';
import { BrandService } from '../../../services/brand/brand.service';
import { EnrollmentService } from '../../../services/enrollment/enrollment.service';
import { DataExchangeService } from '../../../services/session/data-exchange.service';
// import { TextResourceService } from '../../services/text-resource.service';
// import { TranslateService, TranslateModule, TranslateLoader, provideTranslateService } from '@ngx-translate/core';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { HttpClient } from '@angular/common/http';
import { IBrandInfo } from '../../../interfaces/brand/brand-info';

// import { CustomLoader } from './custom-loader';
import { CommonModule } from '@angular/common';
import { NGXLogger } from 'ngx-logger';
import { PhoneMaskDirective } from '../../../directives/phone-mask.directive';

@Component({
    selector: 'app-nonmobile-page-standard',
    standalone: true,
    templateUrl: './nonmobile-page-standard.component.html',
    styleUrl: './nonmobile-page-standard.component.css',
    imports: [
        ReactiveFormsModule,
        // TranslateModule,
        CommonModule,
        PhoneMaskDirective,
        // TranslateModule.forChild({
        //   loader: {
        //     provide: TranslateLoader,
        //     useClass: CustomLoader
        //   }
        // })
    ],
    providers: [
    // provideTranslateService({
    //   loader: {
    //     provide: TranslateLoader,
    //     useClass: CustomLoader
    //   }
    // })
    ]
})
export class NonmobilePageStandardComponent implements OnInit {

  @Input() data: any;

  private readonly router = inject(Router);
  private readonly sharedService = inject(SharedService);
  private readonly brandService = inject(BrandService);
  private readonly dataExchangeService = inject(DataExchangeService);
  private readonly enrollmentService  = inject(EnrollmentService);
  private readonly logger = inject(NGXLogger);
  // private readonly textResourceService = inject( TextResourceService);
  // private readonly translateService = inject(TranslateService);
  // private readonly http = inject(HttpClient);

  successMessage!: string;
  errorMessage!: string;
  isSuccessMessageShown: boolean = false;
  isErrorMessageShown: boolean = false;

  region!: string;
  session!: ISessionDetails;

  emailMeImage: string = '/assets/images/email-me.png';
  smsMeImage: string = '/assets/images/sms-me.png';
  headerText!: string;
  qrInvitationText!: string;
  emailInvitationText!: string;
  smsInvitationText!: string;
  qrCodeUrl!: string;
  isHeaderTextShown: boolean = false;
  isQrInvitationTextShown: boolean = false;
  isSmsInvitationTextShown: boolean = false;
  isEmailInvitationTextShown: boolean = false;
  isQrCodeUrlShown: boolean = false;

  public phoneForm!: FormGroup;
  public emailForm!: FormGroup;
  public emailAddress!: string;
  public phoneNumber!: string;
  public modalTitle!: string;

  isEmailFormOpen = signal(false);
  isPhoneFormOpen = signal(false);

  constructor(private fb: FormBuilder) {
    // this.translateService.use('en');
  }

  ngOnInit() {
    this.region = this.dataExchangeService.getRegion();
    this.session = this.dataExchangeService.getSession();
    if (this.region && this.session) {
      //  Retrieve text resources
      this.getTextResource(this.region, this.session.brandCode || '');
      //  Retrieve brand confiiguration from the "master" brand table
      // this.getBrandConfig(this.region, this.session.brandCode || '');
      this.setCustomizations();
      // Retrieve the QR code url
      this.getQRCode(this.region, this.session.walPageUuid || '', this.session.source);
    }
    this.phoneForm = this.fb.group({
      phoneNumber: [this.phoneNumber, [Validators.pattern("^(\\([0-9]{3}\\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$")]]
    });
    this.emailForm = this.fb.group({
      emailAddress: [this.emailAddress, [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]]
    });

      // Translation services
      // const language: string = 'en';
      // const loader = new TranslateHttpLoader(this.http, '/assets/i18n/', '.json');
      // this.translateService.use(language);

  }

  public setCustomizations() {
    let brandInfo: IBrandInfo = this.dataExchangeService.getBrandInfo();
    let isSmsEnabled: boolean = Boolean(this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_NONMOBILE_IS_SMS_ENABLED') === "true");
    this.headerText = this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_NONMOBILE_TITLE');
    this.emailInvitationText = this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_NONMOBILE_EMAIL_INPUT_PROMPT');
    this.smsInvitationText = this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_NONMOBILE_SMS_INPUT_PROMPT');
    this.qrInvitationText = this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_NONMOBILE_QR_INVITE_TEXT');
    this.isHeaderTextShown = this.headerText ? true : false;
    this.isEmailInvitationTextShown = this.emailInvitationText ? true : false;
    this.isSmsInvitationTextShown = (this.smsInvitationText && this.smsInvitationText.trim() !== "" && isSmsEnabled) ? true : false;
    this.isQrInvitationTextShown = this.qrInvitationText ? true : false;
  }

  public getQRCode(region: string, sessionId: string, source?: string) {
    // Make a web api call
    this.enrollmentService.getQRCode(region, sessionId, source)
    .subscribe({
      next: (response) => {
        if (response) {
          this.qrCodeUrl = response.qrUrl;
          this.isQrCodeUrlShown = true;
        }
      },
      error: (error) => {
        // this.logger.error('NonmobilePageStandardComponent - getQRCode', error);
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });
  }

  public getTextResource(region: string, brandCode: string) {
    // this.textResourceService.getTestResources(region, brandCode, "en", "nm-page")
    // .subscribe({
    //   next: (response) => {
    //     if (response) {
    //     }
    //   },
    //   error: (error) => {
    //     this.dataExchangeService.setMessageHeader('ACI Walletron');
    //     this.dataExchangeService.setMessageText(error);
    //     this.router.navigate(['/err']);
    //   },
    //   complete: () => {
    //   }
    // });
  }




  onOpenSMSModal() {
    this.modalTitle = 'Enter Phone Number';
    this.isPhoneFormOpen.set(true);
  }

  onOpenEmailModal() {
    this.modalTitle = 'Enter Email Address';
    this.isEmailFormOpen.set(true);
  }

  onSendSMS() {
    this.isSuccessMessageShown = false;
    this.isErrorMessageShown = false;
    this.enrollmentService.sendSMSInvitation(this.region, this.session.walPageUuid, this.phoneForm.value.phoneNumber)
    .subscribe({
      next: (response) => {
          this.successMessage = response.returnMessage;
          this.isSuccessMessageShown = true;
      },
      error: (error) => {
        // this.logger.error('NonmobilePageStandardComponent - onSendSMS', error);
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });
  }

  onSendEmail() {
    this.isSuccessMessageShown = false;
    this.isErrorMessageShown = false;
    this.enrollmentService.sendEmailInvitation(this.region, this.session.walPageUuid, this.emailForm.value.emailAddress)
    .subscribe({
      next: (response) => {
          this.successMessage = response.returnMessage; //'An email invitation has been sent out.';
          this.isSuccessMessageShown = true;
      },
      error: (error) => {
        // this.logger.error('NonmobilePageStandardComponent - onSendEmail', error);
        this.dataExchangeService.setMessageText(error);
        this.router.navigate(['/err']);
      },
      complete: () => {
      }
    });
  }

  onClose() {
    window.open('','_parent','');
    window.close();
  }

  formChanged() {
  }

  closeModal() {
    this.isPhoneFormOpen.set(false);
    this.isEmailFormOpen.set(false);
  }


}
